<section>
  <article>
    <h1 i18n>Under Construction!</h1>
    <p i18n>This page is currently in development.</p>
  </article>
</section>
